import type { ReactNode } from "react";
import styles from "./SettingsCard.module.scss";
import { combineClasses } from "@/lib/utils";

export interface SettingsCardProps {
  title: string;
  subtitle?: string;
  badge?: ReactNode;
  headerAction?: ReactNode;
  className?: string;
  children: ReactNode;
}

const SettingsCard = ({
  title,
  subtitle,
  badge,
  headerAction,
  className = "",
  children,
}: SettingsCardProps) => {
  return (
    <section className={combineClasses(styles.card, className)}>
      <div className={styles.cardHeader}>
        <div className={styles.titleBlock}>
          <h2 className={styles.cardTitle}>{title}</h2>
          {subtitle && <p className={styles.cardSubtitle}>{subtitle}</p>}
        </div>
        {(badge || headerAction) && (
          <div className={styles.headerRight}>
            {badge}
            {headerAction}
          </div>
        )}
      </div>
      <div className={styles.cardContent}>{children}</div>
    </section>
  );
};

export default SettingsCard;
